import { useContext, useState } from 'react';

import { ModalContext, AppContext } from 'commons-ui';
import useService from '../useService';

const useContent = (props: any) => {
	const { refundSuggestionDetails, tournamentDetails } = props;
	const { createTournamentRefundRequest } = useService();
	const { setModalConfig } = useContext(ModalContext);
	const { showAlert } = useContext(AppContext);
	const [showLoader, setShowLoader] = useState(false);

	const handleSubmit = async (submittedData: any) => {
		const reqParams = { ...refundSuggestionDetails, ...tournamentDetails, ...submittedData };
		setShowLoader(true);
		const result = await createTournamentRefundRequest(reqParams);

		if (result.data.success) {
			showAlert('Refund request created successfully', { type: 'success' });
		} else {
			showAlert('Failed Refund request creation.', { type: 'error' });
		}
		setModalConfig({ isOpen: false });
		setShowLoader(false);
	};

	const handleCancel = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		handleSubmit,
		handleCancel,
		showLoader,
		setShowLoader
	};
};

export default useContent;
